import React, { useState } from "react";
import { trackEventOnce } from "../../services/analytics/track";
import PrettoSlider from "../simulator/PrettoSlider";
import Numeral from "../numeral/Numeral";
import { RadioGroup } from "@headlessui/react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";
import { calcularFechas } from "./calculoFechas";
import moment from "moment";
import { time, usura } from "../../utils/TMLV";
import { HttpRequest } from "../../services/httpRequest";


let Tmlv = null;
let _time = time;
let _usura = usura;

const getTlmv = async () => {
  try {
    let data = await HttpRequest.getTMLV();
    //console.log(data.message.data);
    if (data.message?.data) {
      localStorage.setItem('tmlv', JSON.stringify(data.message.data));
    }
  } catch (error) {
    console.log(error);
    return error;
  }
}

getTlmv().then(() => {
  let _tmlvData = localStorage.getItem('tmlv');
  if (_tmlvData) {
    try {
      Tmlv = JSON.parse(_tmlvData);
      if (Tmlv) {
        _time = Tmlv[0]?.date ?? "";
        _usura = `${Tmlv[0]?.rate}${Tmlv[0]?.percent} ${Tmlv[0]?.text}`;
      }
    } catch (error) {
      console.log(error);
    }
  }
})


const fechasOptions = calcularFechas();

const dateLimit1 = fechasOptions.fecha1.format("DD/MM/YYYY");
const dateLimit2 = fechasOptions.fecha2.format("DD/MM/YYYY");
const vence1 = fechasOptions.fecha1.diff(moment(), "days");
const vence2 = fechasOptions.fecha2.diff(moment(), "days");

const timepay = [
  { id: 1, value: vence1 + 1 },
  { id: 2, value: vence2 + 1 },
];

const datepay = [
  {
    id: 1,
    day: fechasOptions.fecha1Day,
    datelimit: dateLimit1,
    value: timepay[0].value,
    expira: `Vence en ${timepay[0].value} días`,
  },
  {
    id: 2,
    day: fechasOptions.fecha2Day,
    datelimit: dateLimit2,
    value: timepay[1].value,
    expira: `Vence en ${timepay[1].value} días`,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function SimulatorCuotas(props) {
  const [Amount, setAmount] = useState(props.default);
  const [Fee, setFee] = useState(props.feeDefault);
  const [selectedMailingLists, setSelectedMailingLists] = useState(datepay[1]);

  const maxAmount = props.maxAmn;
  const minAmount = props.minAmn;
  const step = props.step;

  const maxFee = props.maxFee;
  const minFee = props.minFee;
  const stepFee = props.stepFee;

  //Calcular interes
  const interest = Math.round(Amount * 0.0188 * Fee);

  const admon = 60000 * Fee;

  //Calcular IVA
  const iva = Math.round(admon * (19 / 100));

  //Calcular Total
  const total = Math.round(Amount + interest + admon + iva);

  //Calcular Cuotas
  const fee = Math.round(total / Fee);

  return (
    <div>
      <div class="relative pt-1">
        <div className="flex justify-between">
          <span className="text-lg font-medium">{props.title}</span>
          <Numeral
            className="text-lg font-medium"
            format={"$0,0"}
            value={Amount}
          />
        </div>
        <PrettoSlider
          value={Amount}
          step={step}
          onChange={(event, vAmnt) => {
            setAmount(vAmnt);
            trackEventOnce("simulador-cuotas", "simulador_usado", { simulador: "cuotas", monto: vAmnt });
          }}
          defaultValue={Amount}
          max={maxAmount}
          min={minAmount}
        />
      </div>
      <div class={props.class || "relative"}>
        <span className="text-lg font-medium">{props.title2}</span>
        <PrettoSlider
          value={Fee}
          step={stepFee}
          onChange={(event, vFee) => {
            setFee(vFee);
          }}
          defaultValue={Fee}
          max={maxFee}
          min={minFee}
        />
        <div className="flex justify-between font-bold">
          <span>3</span>
          <span>4</span>
          <span>5</span>
          <span>6</span>
        </div>
      </div>
      <div className="mt-4">
        <div className="text-sm flex justify-between">
          <span>Interés corriente</span>
          <div className="flex">
            <span>(25% E.A)</span>
            <InformationCircleIcon
              data-tooltip-id="int"
              className="w-4 h-auto ml-0.5 font-bold cursor-pointer"
            />
            <Tooltip
              place="top"
              id="int"
              className="w-72"
            >
              La tasa de interés corriente aplicada a tu crédito es de 25% E.A
              (Efectivo Anual) sobre el capital adeudado, para {_time} la tasa
              máxima fijada por las autoridades en Colombia es del {_usura}.
            </Tooltip>
          </div>
        </div>
        <div className="text-sm flex justify-between">
          <span>Administración</span>
          <div className="flex">
            <Numeral format={"$0,0"} value={60000} />
            <InformationCircleIcon
              data-tooltip-id="admon"
              className="w-4 h-auto ml-0.5 font-bold cursor-pointer"
            />
            <Tooltip
              place="top"
              id="admon"
              className="w-72"
            >
              Se paga mes vencido y te permite realizar solicitudes en línea,
              garantizar un cupo de crédito rotativo, firmar documentos
              electrónicamente y acceder a los beneficios de Galilea. Su valor
              no incluye IVA*
            </Tooltip>
          </div>
        </div>
        <div className="text-base pt-4 font-medium flex justify-between">
          <span>{Fee} cuotas de</span>
          <Numeral format={"$0,0"} value={fee} />
        </div>
        <RadioGroup
          value={selectedMailingLists}
          onChange={setSelectedMailingLists}
          className="text-sm flex justify-between"
        >
          <span>Tu primera fecha</span>
          {datepay.map((datepay) => (
            <RadioGroup.Option
              key={datepay.id}
              value={datepay}
              className={({ checked, active }) =>
                classNames(
                  checked ? "text-tdark" : "hidden",
                  active ? "text-tdark" : "text-tdark"
                )
              }
            >
              {({ checked, active }) => (
                <div>
                  <RadioGroup.Description as="span">
                    {datepay.datelimit}
                  </RadioGroup.Description>
                </div>
              )}
            </RadioGroup.Option>
          ))}
        </RadioGroup>
        <div className="flex pt-4 items-center">
          <input
            /* onChange={handleChange} */
            id="terms"
            name="terms"
            required
            type="checkbox"
            className="h-4 w-4 text-purple focus:ring-0 border-gray-300 rounded-sm"
          />
          <label className="ml-2 block">
            Acepto los{" "}
            <a href="/terminos" className="text-purple underline">
              {" "}
              Términos y condiciones.{" "}
            </a>
          </label>
        </div>
      </div>
    </div>
  );
}
